import $ from 'jquery';

const calculateHeaderHeight = () => {
	const el = {
		header: '.elementor-location-header',
	};

	const init = () => {
		$(function () {
			if (!$(el.header).length) return;

			exec();

			$(window).on('resize', exec);
		});
	};

	const exec = () => {
		$(document.body).css('--header-height', $(el.header).height() + 'px');
	};

	init();
};

try {
	calculateHeaderHeight();
} catch (error) {
	console.error(error);
}
